import React from 'react';

const UsersList = ({ users, mainUserId, selectedUser, handleUserSelect }) => {
  if (!users || !users.length) {
    return null;
  }

  return (
    <React.Fragment>
      <h3> User list </h3>
      <table className="table table-striped">
        <thead>
          <tr>
            <th>User ID</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Email</th>
            <th>Role</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {users
            .filter((user) => user.id !== mainUserId)
            .map((user) => (
              <tr className="transfer-sub-users" key={user.id}>
                <td>{user.id}</td>
                <td>{user.first_name}</td>
                <td>{user.last_name}</td>
                <td>{user.email}</td>
                <td>{user.acl_group_name}</td>
                <td>
                  <button
                    className={
                      selectedUser && selectedUser.id === user.id
                        ? 'btn btn-primary'
                        : 'btn btn-default'
                    }
                    onClick={() => handleUserSelect(user)}
                  >
                    {selectedUser && selectedUser.id === user.id
                      ? 'Selected'
                      : 'Select'}
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </React.Fragment>
  );
};

export default UsersList;
